/**
 * Renders the recommended products inside the overlay.
 * @param {HTMLElement} overlay - The overlay element to render recommendations in.
 * Is assumed it is a valid overlay element according to the back in stock app block.
 */
async function getRecommendations(overlay) {
  const recommendationLimit = overlay.querySelector('input[name="recommendation_limit"]')?.value;
  const recommendationProductId = overlay.querySelector('input[name="recommendation_product_id"]')?.value;

  const url = new URL(window.location.origin + '/recommendations/products.json');
  url.searchParams.append('product_id', recommendationProductId);
  url.searchParams.append('limit', recommendationLimit);

  const track = overlay.querySelector('rich-carousel .rich-carousel__track');

  const products = await fetch(url.toString())
    .then(res => res.json())
    .then(data => {
      return data.products.map(product => window.createMiniProductCard(product));
    })
    .catch(() => {
      track.parentElement?.remove();
      const recommendations = overlay.querySelector('.back-in-stock__overlay__recommendations');
      recommendations.innerHTML = '';
      window.setErrorMessage(recommendations, 'Failed to load recommended products. Please try again later.');
      return [];
    });
  
  if (products.length === 0) {
    return
  }

  const fragment = document.createDocumentFragment();
  products?.forEach(productCard => {
    fragment.appendChild(productCard);
  });

  
  track.innerHTML = '';
  Array.from(fragment.children).forEach(child => {
    track.appendChild(child);
  });
}
window.getRecommendations = getRecommendations;

document.addEventListener('DOMContentLoaded', () => {
  const backInStockButton = document.querySelector('.back-in-stock__button');
  const backInStockOverlay = document.querySelector('.back-in-stock__overlay');

  if (backInStockButton && backInStockOverlay) {
    backInStockButton.addEventListener('click', () => window.toggleOverlay(backInStockOverlay));

    const closeButton = backInStockOverlay.querySelector('.close__overlay');
    closeButton?.addEventListener('click', () => window.toggleOverlay(backInStockOverlay));
  }

  const phoneInput = document.querySelector('.back-in-stock__phone');
  if (phoneInput && window.intlTelInput) {
    window.backInStockPhoneIti = window.intlTelInput(phoneInput, {
      initialCountry: 'au',
      strictMode: true,
    });
  }

  const backInStockForm = document.querySelector('.back-in-stock__overlay form');
  if (backInStockForm) {
    if (backInStockOverlay.querySelector('rich-carousel')) {
      getRecommendations(backInStockOverlay);
    }

    backInStockForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      const formData = new FormData(backInStockForm);
      const itiInstance = window.backInStockPhoneIti;
      const variantId = formData.get('variantId');
      const apiKey = formData.get('apiKey');

      const phoneValue = phoneInput.value.trim();

      if (phoneValue) {
        if (itiInstance && itiInstance.isValidNumber()) {
          formData.set('phone', itiInstance.getNumber());
        } else {
          window.setErrorMessage(backInStockForm, 'Please enter a valid phone number.');
          return;
        }
      }

      const submitButton = backInStockForm.querySelector('button[type="submit"]');
      if (!submitButton) {
        console.error('Submit button not found in the back in stock form.');
        return;
      }

      const oldHtml = submitButton.outerHTML;
      window.setLoading(submitButton);

      const channels = ['EMAIL'];
      if (phoneValue) {
        channels.push('SMS');
      }
      // TODO: CONNECT TO KLAVIYO API
      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${apiKey}`, {
        method: 'POST',
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: formData.get('email'),
                    ...(phoneValue ? { phone_number: formData.get('phone') } : {})
                  }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        }),
        headers: {
          'revision': '2026-07-15',
          'accept': 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
        }
      })
      .then(async res => {
        if (res.ok) {
          window.setSuccessMessage(
            backInStockForm,
            `You have successfully subscribed to back in stock notifications.`
          );
          return;
        }

        // Error responses do return a JSON:API body - parse it for the real
        // detail message, but fall back gracefully if that parse itself fails.
        const data = await res.json().catch(() => null);
        throw new Error(data?.errors?.[0]?.detail || 'An error occurred. Please try again.');
      })
      .catch(error => {
        window.setErrorMessage(backInStockForm, error.message || 'An error occurred. Please try again.');
      })
      .finally(() => {
        window.setLoading(submitButton, oldHtml);
      });
    });
  } else {
    console.error('Back in stock form not found inside back in stock overlay.');
  }
});